import { Box, JustifyContent } from "@gocardless/flux-react";

import { marketingBackgroundColor } from "../consts";
import { ExpiredReferralCode } from "../form-field-components/ExpiredReferralCode";

import { SignUpMarketing } from "./signup-marketing/SignUpMarketing";
import { SignUpGetStartedFooter } from "./SignUpGetStartedFooter";
import {
  SignUpGetStartedForm,
  SignUpGetStartedFormProps,
} from "./sigup-get-started-form/SignUpGetStartedForm";

import { VerticalSplitPageLayout } from "src/components/layout/VerticalSplitPage/VerticalSplitPageLayout";

const FormContent = ({
  country,
  accountType,
  referralGeo,
  referralCode,
  referralVariation,
  referralCodeName,
  isPaymentProvider,
  hasFsbMemberDiscount,
  referralSource,
  submit,
}: SignUpGetStartedFormProps) => (
  <Box
    width="100%"
    height="100%"
    layout="flex"
    flexDirection="column"
    justifyContent={[JustifyContent.Start, null, null, JustifyContent.Center]}
  >
    {/* Temp to invalidate usage of V2 referral codes.
        V3 codes are all 6 characters in length.
    */}
    {referralCode && referralCode.length > 6 ? (
      <ExpiredReferralCode />
    ) : (
      <SignUpGetStartedForm
        country={country}
        accountType={accountType}
        referralGeo={referralGeo}
        referralCode={referralCode}
        referralCodeName={referralCodeName}
        referralVariation={referralVariation}
        isPaymentProvider={isPaymentProvider}
        hasFsbMemberDiscount={hasFsbMemberDiscount}
        referralSource={referralSource}
        submit={submit}
      />
    )}
    <Box width="100%" spaceAbove={2} spaceBelow={1.5}>
      <SignUpGetStartedFooter />
    </Box>
  </Box>
);

export const SignUpGetStarted = (props: SignUpGetStartedFormProps) => (
  <VerticalSplitPageLayout
    logoVariant="light"
    logoURL="https://gocardless.com"
    leftContent={<SignUpMarketing />}
    leftBackground={{
      backgroundColor: marketingBackgroundColor,
    }}
    rightContent={<FormContent {...props} />}
  />
);
